export default {"src":"/_next/static/image/public/images/ic_manage_family_white_vertical_menu.104beea3c5929632e6de1a76af9013d7.svg","height":20,"width":20};